<template>
	<div class="userManage">
		<!-- 筛选条件 -->
		<filterBar s_name="教师" @searchName="setSearchName" @school_search="setSchool_search"
			@dept_search="setDept_search" @major_search="setMajor_search" @class_search="setClass_search"
			:getSchoolArray="getSchoolArray" :getDeptArray="getDeptArray" :getMajorArray="getMajorArray"
			:getClassArray="getClassArray">
			<el-button type="primary" plain @click="loadData">加载用户</el-button>
		</filterBar>
		<!-- 列表 -->
		<el-card shadow="hover" style="margin-top: 10px;">
			<div slot="header" class="clearfix">
				<span>用户列表({{tableDataCount}})</span><span
					style="font-size: 12px;color:#aaa;margin-left: 50px;">查询-请先选择筛选条件</span>
				<el-button style="float: right; padding: 3px 0" type="text" @click="addDialogVisible = true">添加教师
				</el-button>
			</div>
			<el-table :data="showDate()" style="width: 100%;margin-bottom: 20px;">
				<el-table-column type="index" label="#" align="center">
					<template slot-scope="scope">
						{{scope.$index + 1}}
					</template>
				</el-table-column>
				<el-table-column prop="name" label="姓名">
					<template slot-scope="scope">
						<div v-html="scope.row.name.replace(searchName,'<font  color=\'red\'>'+searchName+'</font>')">
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="loginID" label="登录账号" width="150px">
					<template slot-scope="scope">
						<div
							v-html="scope.row.loginID.replace(searchName,'<font  color=\'red\'>'+searchName+'</font>')">
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="loginPwd" label="登录密码"></el-table-column>
				<el-table-column prop="phone" label="手机号"></el-table-column>
				<el-table-column label="校/院/专/班" width="400">
					<template slot-scope="scope">
						{{showSchoolName(scope.row.schoolID)+'/'+showDeptName(scope.row.deptID)+'/'+showMajorName(scope.row.majorID)+'/'+showClassName(scope.row.classID)}}
					</template>
				</el-table-column>
				<el-table-column label="用户状态" width="100">
					<template slot-scope="scope">
						<el-switch @change="editUserState(scope.row)" v-model="scope.row.state==1?true:false"
							active-color="#13ce66" inactive-color="#ff4949">
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column prop="stopTime" label="到期时间" width="200"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="200"></el-table-column>
				<el-table-column label="操作" fixed="right" width="200">
					<template slot-scope="scope">
						<el-button size="mini" style="margin-right: 10px;" icon="el-icon-edit" @click="edit(scope.row)">
							编辑</el-button>

						<el-popconfirm title="确定要删除吗" @confirm="del(scope.row)">
							<el-button size="mini" type="danger" icon="el-icon-delete" slot="reference">
								删除</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="tableDataCount"
				class="pagination" @size-change="sizeChange" @current-change="currentChange">
			</el-pagination>
		</el-card>
		<!-- 添加教师 -->
		<edit @before-close="closeEditDialog" :outerVisible="addDialogVisible" dialogType="add" :roleID="roleID"
			:getSchoolArray="getSchoolArray" :getDeptArray="getDeptArray" :getMajorArray="getMajorArray"
			:getClassArray="getClassArray">
		</edit>
		<!-- 编辑教师 -->
		<edit @before-close="closeEditDialog" :outerVisible="editDialogVisible" dialogType="up" :objdata="dialogModels"
			:roleID="roleID" :getSchoolArray="getSchoolArray" :getDeptArray="getDeptArray"
			:getMajorArray="getMajorArray" :getClassArray="getClassArray"></edit>
	</div>
</template>

<script>
	import filterBar from '@/components/org-filterbar/filterbar4.vue'
	import edit from './user/edit.vue'

	import {
		mapGetters
	} from 'vuex'

	export default {
		data() {
			return {
				//分页数据
				data: [],
				page_size: 10,
				page_current: 1,
				tableDataCount: 0,
				//页面列表 筛选条件
				searchName: '',
				school_search: '',
				dept_search: '',
				major_search: '',
				class_search: '',
				getSchoolArray: [],
				getDeptArray: [],
				getMajorArray: [],
				getClassArray: [],
				//添加 修改
				editDialogVisible: false,
				addDialogVisible: false,
				dialogModels: {},
				roleID: 4
			}
		},
		computed: {
			...mapGetters(['getUserInfo'])
		},
		created() {
			this.loadOrg()
		},
		components: {
			filterBar,
			edit
		},
		methods: {
			async loadOrg() {
				await this.$http.get('api/Org/GetSchools').then(res => {
					this.getSchoolArray = res.data.data
				})
				await this.$http.get('api/Org/GetDept/').then(res => {
					this.getDeptArray = res.data.data
				})
				await this.$http.get('api/Org/GetMajor/').then(res => {
					this.getMajorArray = res.data.data
				})
				await this.$http.get('api/Org/GetClass').then(res => {
					this.getClassArray = res.data.data
				})

				if (this.getUserInfo.roleID != 1) {
					this.loadData()
				}
			},
			loadData() {
				let orgID = ''
				if (this.school_search) {
					orgID = this.school_search
				}
				if (this.dept_search) {
					orgID = this.dept_search
				}
				if (this.major_search) {
					orgID = this.major_search
				}
				if (this.class_search) {
					orgID = this.class_search
				}
				if (orgID == '') {
					this.$message({
						message: '查询-请先选择筛选条件',
						type: 'info'
					})
					return false
				}

				this.$http.get('api/User/GetUsers/' + this.roleID + '/' + orgID).then(res => {
					this.data = res.data.data
				})
			},
			//筛选条件
			setSearchName(val) {
				this.searchName = val
				this.page_current = 1
			},
			setSchool_search(val) {
				this.school_search = val
			},
			setDept_search(val) {
				this.dept_search = val
			},
			setMajor_search(val) {
				this.major_search = val
			},
			setClass_search(val) {
				this.class_search = val
			},
			//分页
			sizeChange(e) {
				this.page_size = e
			},
			currentChange(e) {
				this.page_current = e
			},
			showDate() {
				if (this.data) {
					let _data = this.data
						.filter(item => item.name &&
							(
								item.name.search(this.searchName) > -1 ||
								item.loginID.search(this.searchName) > -1
							) &&
							item.schoolID.search(this.school_search) > -1 &&
							item.deptID.search(this.dept_search) > -1 &&
							item.majorID.search(this.major_search) > -1 &&
							item.classID.search(this.class_search) > -1)
					this.tableDataCount = _data.length
					return _data.slice((this.page_current - 1) * this.page_size, this.page_current * this.page_size)
				}
			},
			showSchoolName(val) {
				let school = this.getSchoolArray.find(item => {
					return item.id == val
				})
				if (school) {
					return school.name
				}
				return ''
			},
			showDeptName(val) {
				let dept = this.getDeptArray.find(item => {
					return item.id == val
				})
				if (dept) {
					return dept.name
				}
				return ''
			},
			showMajorName(val) {
				let major = this.getMajorArray.find(item => {
					return item.id == val
				})
				if (major) {
					return major.name
				}
				return ''
			},
			showClassName(val) {
				let _class = this.getClassArray.find(item => {
					return item.id == val
				})
				if (_class) {
					return _class.name
				}
				return ''
			},
			//修改用户状态
			editUserState(users) {
				users.state = users.state == 0 ? 1 : 0
				this.$http.get('api/User/EditUserState/' + users.id + '/' + users.state)
					.then(res => {

					})
					.catch(ex => {
						this.$message({
							message: ex.body,
							type: 'danger'
						})
					})
			},
			del(data) {
				this.$http.get('api/User/DelUsersOne/' + data.id)
					.then(res => {
						if (res.data.code == "1") {
							this.$message({
								message: "教师删除成功",
								type: 'success'
							})
							this.loadData()
						}
					})
					.catch(ex => {
						this.$message({
							message: ex.body,
							type: 'danger'
						})
					})
			},
			edit(val) {
				this.dialogModels = val
				this.editDialogVisible = true
			},
			closeEditDialog(val) {
				//关闭所有弹出框
				this.editDialogVisible = false
				this.addDialogVisible = false
				//刷新列表数据
				if (val == true) {
					this.loadData()
				}
			}
		}
	}
</script>

<style lang="scss">
	.userManage {
		.pagination {
			margin: 10px 0;
			text-align: center;
		}
	}
</style>
